import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function InvitadosPublic() {
  const [guests, setGuests] = useState([]);
  const [eps, setEps] = useState([]);

  useEffect(() => {
    document.title = "Invitados — Modo Pro";
    api.get("/guests").then((r) => setGuests(r.data)).catch(() => {});
    api.get("/episodes").then((r) => setEps(r.data)).catch(() => {});
  }, []);

  const episodeFor = (g) => eps.find((e) => e.id === g.episode_id);

  return (
    <main data-testid="invitados-page" className="bg-mp-black min-h-screen pt-32 md:pt-40">
      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-16">
        <div className="mp-eyebrow mb-6">Invitados</div>
        <h1 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em] max-w-3xl">
          Personas que <span className="text-mp-orange">saben</span> de lo que hablan.
        </h1>
        <p className="mt-6 text-mp-mute font-display text-sm tracking-[0.24em] uppercase">
          Empresarios · Médicos · Emprendedores · Ejecutivos · Creadores · Profesionales · Expertos
        </p>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 lg:px-12 pb-24">
        {guests.length === 0 ? (
          <div className="border border-white/10 p-10 md:p-16 bg-mp-off">
            <p className="font-display text-white text-xl md:text-2xl leading-tight max-w-2xl">
              <span className="text-mp-orange">Expertos, empresarios y profesionales</span> que aportan
              experiencia real, conocimiento y perspectivas que nuestra comunidad puede convertir en
              mejores decisiones.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {guests.map((g) => {
              const ep = episodeFor(g);
              return (
                <article key={g.id} data-testid={`pub-guest-${g.id}`} className="group relative aspect-[3/4] overflow-hidden border border-white/10">
                  {g.photo_url ? (
                    <img src={g.photo_url} alt={g.name} className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="h-full w-full bg-mp-charcoal" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 inset-x-0 p-5">
                    <div className="text-mp-orange text-[10px] tracking-[0.28em] uppercase font-display">{g.category}</div>
                    <div className="mt-1 font-display text-white text-lg leading-tight">{g.name}</div>
                    <div className="text-white/70 text-xs mt-1">{g.profession}</div>
                    {g.company && <div className="text-white/50 text-xs mt-1">{g.company}</div>}
                    {ep?.is_published && (ep.youtube_url || ep.spotify_url) && (
                      <a href={ep.youtube_url || ep.spotify_url} target="_blank" rel="noreferrer" className="mt-3 inline-block mp-link-underline text-mp-orange text-[10px] tracking-[0.24em] uppercase font-display">
                        Ver episodio
                      </a>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </section>
    </main>
  );
}
